import { Card, CardContent, Grid } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import BusinessIcon from "@mui/icons-material/Business";
import EventNoteIcon from "@mui/icons-material/EventNote";
import { SummaryCard } from "./SummaryCard";
import { useDashboard } from "../context/useDashboard";
import { TabletAndroid } from "@mui/icons-material";
import { Box, Skeleton } from "@mui/material";
import { Can } from "../../../shared/components/Permission/Can";
import PetsIcon from "@mui/icons-material/Pets";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import PersonIcon from "@mui/icons-material/Person";
import { ROLES } from "../../../shared/constants/roles";

export const SummaryCards = () => {
  const { dashboardCounts, petsAndVehiclesCounts, dashboardSummaryToday, isLoadingDashboardCounts, isLoadingPetsAndVehiclesCounts, isLoadingDashboardSummaryToday } = useDashboard();

  console.log('Dashboard Counts:', dashboardCounts);
  console.log('Pets and Vehicles Counts:', petsAndVehiclesCounts);
  console.log('Dashboard Summary Today:', dashboardSummaryToday);

  // Calcular total de pets e veículos
  const totalPets = petsAndVehiclesCounts?.items?.reduce((total, item) => total + item.pets.length, 0) || 0;
  const totalVehicles = petsAndVehiclesCounts?.items?.reduce((total, item) => total + item.vehicles.length, 0) || 0;
  const totalVisitors = dashboardSummaryToday?.visitors?.length || 0;

  if (isLoadingDashboardCounts || isLoadingDashboardSummaryToday || !dashboardCounts || !dashboardSummaryToday) {
    return (
      <Grid container spacing={3} mb={3}>
        {[1, 2, 3, 4, 5, 6, 7].map((index) => (
          <Grid item xs={12} md={3} key={index}>
            <Card>
              <CardContent>
                <Box display="flex" alignItems="center" gap={2}>
                  <Skeleton variant="circular" width={40} height={40} />
                  <Box flex={1}>
                    <Skeleton variant="text" width="60%" height={24} />
                    <Skeleton variant="text" width="40%" height={20} />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <Grid container spacing={3} mb={3}>
      <Can roles={[ROLES.ADMIN, ROLES.GESTOR]}>
        <Grid item xs={12} md={3}>
          <SummaryCard
            icon={
              <PeopleIcon
                sx={{
                  fontSize: 40,
                  color: "primary.main",
                  bgcolor: "#F4F6FA",
                  borderRadius: 2,
                  p: 1,
                }}
              />
            }
            value={dashboardCounts.activeUsers}
            label="Usuários Ativos"
          />
        </Grid>
        <Grid item xs={12} md={3}>
        <SummaryCard
          icon={
            <BusinessIcon
              sx={{
                fontSize: 40,
                color: "success.main",
                bgcolor: "#F4F6FA",
                borderRadius: 2,
                p: 1,
              }}
            />
          }
          value={dashboardCounts.companies}
          label="Empresas"
        />
      </Grid>
         
      <Grid item xs={12} md={3}>
        <SummaryCard
          icon={
            <TabletAndroid
              sx={{
                fontSize: 40,
                color: "warning.main",
                bgcolor: "#F4F6FA",
                borderRadius: 2,
                p: 1,
              }}
            />
          }
          value={dashboardCounts.equipment}
          label="Equipamentos"
        />
      </Grid>
      </Can>
  
      <Grid item xs={12} md={3}>
        <SummaryCard
          icon={
            <EventNoteIcon
              sx={{
                fontSize: 40,
                color: "warning.main",
                bgcolor: "#F4F6FA",
                borderRadius: 2,
                p: 1,
              }}
            />
          }
          value={dashboardCounts.reservations}
          label="Reservas"
        />
      </Grid>

      <Can roles={[ROLES.USER, ROLES.CUSTOMER]}>
        <Grid item xs={12} md={3}>
          <SummaryCard
            icon={
              <PersonIcon
                sx={{
                  fontSize: 40,
                  color: "info.main",
                  bgcolor: "#F4F6FA",
                  borderRadius: 2,
                  p: 1,
                }}
              />
            }
            value={totalVisitors}
            label="Visitantes"
          />
        </Grid>
        {petsAndVehiclesCounts && (
          <>
            <Grid item xs={12} md={3}>
              <SummaryCard
                icon={
                  <PetsIcon
                    sx={{
                      fontSize: 40,
                      color: "secondary.main",
                      bgcolor: "#F4F6FA",
                      borderRadius: 2,
                      p: 1,
                    }}
                  />
                }
                value={totalPets}
                label="Pets"
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <SummaryCard
                icon={
                  <DirectionsCarIcon
                    sx={{
                      fontSize: 40,
                      color: "error.main",
                      bgcolor: "#F4F6FA",
                      borderRadius: 2,
                      p: 1,
                    }}
                  />
                }
                value={totalVehicles}
                label="Veículos"
              />
            </Grid>
          </>
        )}
      </Can>
    </Grid>
  );
}; 